import { Navigate, useRoutes, useLocation, Routes, Route } from 'react-router-dom';
import DashboardLayout from '../layouts/dashboard';
import LogoOnlyLayout from '../layouts/LogoOnlyLayout';
import { PATH_AFTER_LOGIN } from '../config';
import Ads from "../pages/dashboard/Ads";
import CreateAd from "../pages/dashboard/CreateAd";
import Offers from "../pages/dashboard/Offers";
import Offer from "../pages/dashboard/Offer";
import About from "../pages/About";
import { DateRangeProvider } from "../pages/dashboard/DateProvider";
import { SitesProvider } from "../pages/dashboard/SitesProvider";
import Placements from "../pages/dashboard/Placements";
import CreativeMethod from "../pages/dashboard/CreativeMethod";
import CreativeUploads from '../pages/dashboard/CreativeUploads';

import Login from "../components/Login";
import ProtectedRoute from "../components/ProtectedRoute";

// const Loadable = (Component) => (props) => {
//   const { pathname } = useLocation();
//
//   return (
//     <Suspense fallback={<LoadingScreen isDashboard={pathname.includes('/dashboard')} />}>
//       <Component {...props} />
//     </Suspense>
//   );
// };

// const About = Loadable(lazy(() => import('../pages/About')));
// const ComingSoon = Loadable(lazy(() => import('../pages/ComingSoon')));
// const Maintenance = Loadable(lazy(() => import('../pages/Maintenance')));
// const Page500 = Loadable(lazy(() => import('../pages/Page500')));
// const NotFound = Loadable(lazy(() => import('../pages/Page404')));

export default function Router() {
  return (
    <Routes>
      <Route path="auth">
        <Route path="login" element={<Login />} />
      </Route>

      <Route path="dashboard" element={
       <ProtectedRoute>
          <DateRangeProvider>
            <SitesProvider>
              <DashboardLayout />
            </SitesProvider>
          </DateRangeProvider>
        </ProtectedRoute>
      }>
        <Route index element={<Navigate to={PATH_AFTER_LOGIN} replace />} />
        <Route path="ads" element={<Ads />} />
        <Route path="createAd" element={<CreateAd />} />
        <Route path="offer" element={<Offer />} />
        <Route path="offers" element={<Offers />} />
        <Route path="placements" element={<Placements />} />
        <Route path="creativeMethod" element={<CreativeMethod />} />
        <Route path="creativeUploads" element={<CreativeUploads />} />
      </Route>

      <Route path="*" element={<About />} />

    </Routes>
  );
}
